import { WorkerAction } from '../framework/workerAction';

export default {
  notify: new WorkerAction({ name: 'api.domain.notify' }, {}),
};
